import { compose, branch, renderNothing } from 'recompose';
import { connect } from 'react-redux';
import { customFieldsCreateAction } from '@applyboard/ab-common';
var enhancer = compose(branch(function (_ref) {
  var enableAddCustomFields = _ref.enableAddCustomFields;
  return !enableAddCustomFields;
}, renderNothing), connect(function () {
  return {};
}, function (dispatch) {
  return {
    onInsertField: function onInsertField() {
      return dispatch(customFieldsCreateAction());
    }
  };
}));
export default enhancer;